t = require('views/internal/teacup-with-helpers')('board_menu_vis')
{ ldclient } = require 'common/lib/ldclient'

module.exports = t.renderable ({ current, isNewBoard, canChange, mustChange,
  hasSuperAdmins, hasOrg, orgName, privateRestricted, orgRestricted,
  enterpriseRestricted, publicRestricted, hasEnterprise, enterpriseName }) ->

  if mustChange && orgName
    t.p '.quiet', ->
      t.format 'illegal org visibility', { orgName }
  orgLevel = if hasEnterprise
    'with enterprise'
  else if hasSuperAdmins
    'with super admins'
  else if hasOrg
    'with organization'
  else
    'without organization'

  permissionLevels =
    'private':
      iconClass: 'icon-private'
      restricted: privateRestricted
    'org':
      iconClass: 'icon-organization'
      restricted: orgRestricted
      invalid: isNewBoard && !hasOrg
    'enterprise':
      iconClass: 'icon-enterprise-dashboard'
      restricted: enterpriseRestricted
      noEnterprise: !hasEnterprise
      invalid: isNewBoard && !hasOrg
    'public':
      iconClass: 'icon-public'
      restricted: publicRestricted
  if !ldclient.variation('enterprise.company_visible_boards', false)
    delete permissionLevels['enterprise']


  for permissionLevel, { restricted, invalid, iconClass, noEnterprise } of permissionLevels
    t.li ->
      disabled = restricted || invalid || !canChange || noEnterprise
      t.a '.js-select', { class: t.classify('light-hover': !disabled, 'disabled': disabled), href: '#', name: permissionLevel }, ->
        t.span '.icon-sm.vis-icon', { class: iconClass }, ->
        t.check current == permissionLevel, permissionLevel
        t.span '.sub-name', ->
          args = if enterpriseName
            { enterpriseName, orgName }
          else if orgName
            { orgName }
          else
            {}

          t.format ['permission subtext', orgLevel, permissionLevel], args

          if canChange && restricted
            t.raw ' '
            t.span '.error', ->
              if isNewBoard
                t.format ['illegal visibility', 'create']
              else
                t.format ['illegal visibility', 'change']



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_menu_vis.coffee